import { extend } from 'underscore';
import rawItemTemplate from './universal-item-template.pug';
import { OccasionI18nKeys } from '../i18n/occasion-i18n-keys';
import { ItemPreviewI18nKeys } from '../i18n/item-preview-i18n-keys';
import { getPromotionTypeForModel } from '../rules/promotion-type';
import { getPromotionDetailTypeForModel } from '../rules/promotion-detail';

export const getPromotionDataFormatConfig = arg0 => extend({
  OccasionI18nKeys,
  ItemPreviewI18nKeys,
  getPromotionTypeForModel,
  getPromotionDetailTypeForModel,
}, arg0);

export const universalItemTemplate = arg0 => rawItemTemplate(getPromotionDataFormatConfig(arg0));
